import FinanceAdapter from './base';

export default class InternalOrder extends FinanceAdapter {
  modelNamePlural = 'internalOrders';
}
